"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.split");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _project = require("@/api/project/project");
var _school = require("@/api/school/school");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "项目名称"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "项目名称",
        prop: "matchName",
        isShow: true,
        width: "400"
      }, {
        name: "所属项目类型",
        prop: "matchTypeName",
        isShow: true,
        width: "200"
      }, {
        name: "项目开始时间",
        prop: "startTime",
        isShow: true,
        width: "300",
        sortable: true
      }, {
        name: "项目结束时间",
        prop: "endTime",
        isShow: true,
        width: "300",
        sortable: true
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      checkBoxs: [],
      searchName: "",
      options: []
    };
  },
  methods: {
    daoClick: function daoClick() {
      var _this = this;
      (0, _project.exportJiangsuTableSecond)().then(function (res) {
        console.log(res, "re");
        var filename = decodeURI(res.headers["content-disposition"].split("=")[1]);
        _this.commonJs.download(res.data, filename);
      });
    },
    //进入申报列表
    openList: function openList(e) {
      console.log('99999');
      this.$router.push({
        path: "/courseDeclare/declareList",
        query: {
          id: e.id,
          item: e
        }
      });
    },
    //同步所有学校到学校单位中去
    tbsyxx: function tbsyxx() {
      var _this2 = this;
      (0, _project.insertAllSchoolAllMatchSchool)().then(function (res) {
        _this2.$message.success("同步成功！");
      });
    },
    //获取报名表列表
    registrationList: function registrationList(e) {
      console.log("报名表列表数据", e);
      this.$router.push({
        path: "/education/registrationList",
        query: {
          id: e.id
        }
      });
    },
    // 分配项目管理员
    allot: function allot(e) {
      this.$router.push({
        path: "/object/objectAdmin",
        query: {
          id: e.id
        }
      });
    },
    // 项目阶段设置
    editStage: function editStage(e) {
      this.$router.push({
        path: "/object/objectStageSet",
        query: {
          matchId: e.id
        }
      });
    },
    // 项目单位设置
    unit: function unit(e) {
      console.log(e);
      this.$router.push({
        path: "/object/objectUnitSet",
        query: {
          matchId: e.id
        }
      });
    },
    // 模糊搜索
    search: function search(v) {
      this.searchName = v.queryValue;
      this.getProjectList();
    },
    // 项目组别设置
    editGroup: function editGroup(e) {
      this.$router.push({
        path: "/object/objectGroupSet",
        query: {
          matchName: e.matchName,
          matchId: e.id
        }
      });
    },
    // 获取项目列表
    getProjectList: function getProjectList() {
      var _this3 = this;
      (0, _project.projectList)({
        matchType: "",
        name: this.searchName,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize
      }).then(function (res) {
        var data = res.data;
        _this3.listData = data.list;
        _this3.totalData = data.total;
      });
    },
    // 承诺书列表
    promiseList: function promiseList(e) {
      this.$router.push({
        path: "/object/promiseList",
        query: {
          id: e.id
        }
      });
    },
    // 导出作品清单
    outPut: function outPut(e) {
      var _this4 = this;
      var objName = e.matchName;
      (0, _school.exportWorkList)({
        matchId: e.id
      }).then(function (res) {
        _this4.commonJs.download(res, objName + "作品清单.xlsx");
      });
    },
    // 新增
    save: function save() {
      if (this.prCode === "guizhou") {
        this.$router.push("/object/objectGZ-add");
      } else {
        this.$router.push("/object/object-add");
      }
    },
    // 编辑
    edit: function edit(e) {
      if (this.prCode === "guizhou") {
        this.$router.push({
          path: "/object/objectGZ-add",
          query: {
            id: e.id
          }
        });
      } else {
        this.$router.push({
          path: "/object/object-edit",
          query: {
            id: e.id
          }
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this5 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this5.checkBoxs.push(item.id);
      });
    },
    deleteById: function deleteById(row) {
      var _this6 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _project.projectDel)(id).then(function () {
          _this6.getProjectList();
          _this6.$message.success("操作成功。");
        });
      }).catch(function () {
        _this6.$message.info("取消删除。");
      });
    },
    distribution: function distribution() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getProjectList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getProjectList();
    }
  },
  created: function created() {
    this.getProjectList();
    var userInfo = this.$store.state.user.userInfo;
    if (this.prCode == "guizhou") {
      this.defaultColumn = [{
        name: "项目名称",
        prop: "matchName",
        isShow: true,
        width: "400"
      }, {
        name: "专业大类",
        prop: "majorName",
        isShow: true,
        width: "200"
      }, {
        name: "所属项目类型",
        prop: "matchTypeName",
        isShow: true,
        width: "200"
      }, {
        name: "创建时间",
        prop: "createTime",
        isShow: true,
        width: "300",
        sortable: true
      }];
      if (userInfo.roleType == 2) {
        this.defaultColumn.push({
          name: "报名人数",
          prop: "partyCount",
          isShow: true,
          width: "100"
        });
      }
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};